import { useReactiveVar } from '@apollo/client';
import { VideoAgreementRecorderInfo } from '../../VideoAgreementRecorderInfo';
import { VideoAgreementRecorderInstructions } from '../../VideoAgreementRecorderInstructions';
import { VideoAgreementRecorderCamera } from '../../VideoAgreementRecorderCamera';
import { VideoAgreementRecorderResume } from '../../VideoAgreementRecorderResume';
import { useAddVideoAgreementToDocument } from './Hooks/useAddVideoAgreementToDocument';
import {
  videoAgreementRecorderDialogVar,
  setVideoAgreementRecorderDialogVar,
} from './VideoAgreementRecorderDialog.vars';

export const VideoAgreementRecorderContent = () => {
  const { step, textToRead, videoRecorded } = useReactiveVar(
    videoAgreementRecorderDialogVar,
  );
  const { handleAddVideoAgreementToDocument } =
    useAddVideoAgreementToDocument();

  return (
    <>
      {step === 0 && (
        <VideoAgreementRecorderInfo
          onContinue={() => {
            setVideoAgreementRecorderDialogVar({
              step: 1,
              showDialogTitle: true,
            });
          }}
        />
      )}
      {step === 1 && (
        <VideoAgreementRecorderInstructions
          onContinue={() => {
            setVideoAgreementRecorderDialogVar({
              step: 2,
              showDialogTitle: false,
            });
          }}
        />
      )}
      {step === 2 && (
        <VideoAgreementRecorderCamera
          textToRead={textToRead}
          videoDuration={60}
          onClose={() => {
            setVideoAgreementRecorderDialogVar({
              step: 1,
              videoRecorded: null,
              showDialogTitle: true,
            });
          }}
          onVideoRecorded={(newVideoRecorded) => {
            if (!newVideoRecorded) {
              return setVideoAgreementRecorderDialogVar({
                videoRecorded: newVideoRecorded,
                showDialogTitle: false,
              });
            }
            setVideoAgreementRecorderDialogVar({
              step: 3,
              videoRecorded: newVideoRecorded,
              showDialogTitle: true,
            });
          }}
        />
      )}
      {step === 3 && videoRecorded && (
        <VideoAgreementRecorderResume
          videoRecorded={videoRecorded}
          onPlayVideoChange={(playVideo) => {
            setVideoAgreementRecorderDialogVar({
              showDialogTitle: !playVideo,
            });
          }}
          onRecordAgain={() => {
            setVideoAgreementRecorderDialogVar({
              step: 2,
              videoRecorded: null,
              showDialogTitle: false,
            });
          }}
          onFinish={handleAddVideoAgreementToDocument}
        />
      )}
    </>
  );
};
